<template>
  <div class="conversions-parent">
    <div class="conversions-card">
      <div class="title-status-parent">
        <h4 class="conversions-title">{{ $t('tracking.main_pixel_code_title')}}</h4>
      </div>

      <div class="conversions-desc">
        <p class="mb-2">{{ $t('tracking.main_pixel_code_desc')}}</p>
        <ul class="list-decimal ml-4">
          <li>
            {{ $t('tracking.step1')}}
          </li>
          <li v-html="$t('tracking.step2')"></li>
        </ul>
      </div>

      <div class="conversions-actions">
        <!-- here -->
        <ConversionsActions />
      </div>
    </div>

    <vx-card class="targeting-container mt-10 p-0" :noShadow="true">
      <vue-tabs :value="tabs.index" ref="subTabsContainer">
        <v-tab tabKey="conversions">
          <div slot="title">
            <h4 class="tab-title">
              {{ $t("Conversions") }}
            </h4>
          </div>

          <ConversionsTabContent :haveConversions="haveConversions"/>
        </v-tab>

        <v-tab tabKey="connection">
          <div slot="title">
            <h4 class="tab-title">
              {{ $t("Test connection") }}
            </h4>
          </div>

          <ConnectionTestTabContent />
        </v-tab>
      </vue-tabs>
    </vx-card>

    <!-- toaster -->
    <SpeakolNotificationToaster :show="toaster.show" :message="toaster.message" :icon="toaster.icon"
      :closeButtonText="toaster.closeButtonText">
      <template v-slot:close>
        <vs-icon @click="toaster.show=false" class="x-icon" color="#fff" icon="speakol-cancel" icon-pack="speakol">
        </vs-icon>
      </template>
    </SpeakolNotificationToaster>
    <!-- toaster -->
  </div>
</template>

<script>
import SpeakolNotificationToaster from '@/components/SpeakolNotificationToaster'
import ConversionsTable from './components/ConversionsTable'
import ConversionsActions from './components/ConversionsActions'
import {mapGetters} from 'vuex'
import '@/components/vue-nav-tabs/nav-tabs.scss'
import { VueTabs, VTab } from '@/components/vue-nav-tabs/vue-nav-tabs.js'
import SpeakolInput from '../../components/SpeakolInput.vue'
import ConversionsTabContent from './components/ConversionsTabContent.vue'
import ConnectionTestTabContent from './components/ConnectionTestTabContent.vue'

export default {
  components: {
    SpeakolNotificationToaster,
    ConversionsTable,
    ConversionsActions,
    VueTabs,
    VTab,
    SpeakolInput,
    ConversionsTabContent,
    ConnectionTestTabContent
  },
  data () {
    return {
      created: this.$route.query.created,
      tabs: {
        index: 0
      },
      name: this.$route.query.name,
      haveConversions: false,
      toaster: {
        show: false,
        message: '',
        icon: require('@/assets/images/success.svg'),
        closeButtonText: 'close'
      }
    }
  },
  computed: {
    ...mapGetters({
      pixelEvents: 'campaign/pixelEvents',
      pixelTrackingDetails: 'accounts/pixelTrackingDetails'
    })
  },

  async beforeCreate () {
    await this.$store.dispatch('accounts/getPixelTrackingDetails')
    await this.checkConversionsCount()
  },

  mounted () {
    this.$on('show-toaster', action => {
      this.handleShowToaster(action)
    })

    if (this.$route.query.testConnection == 1) {
      this.tabs.index = 1
    }
  },
  created () {
    if (this.created === true) {
      this.toaster.show = true
      this.toaster.message = `"${this.name}" conversion has been created.`
      setTimeout(() => {
        this.toaster.show = false
      }, 3000)
    }
  },
  methods: {
    handleShowToaster (action) {
      if (action === 'copy') {
        this.toaster.show = true
        this.toaster.message = 'The Pixel Code has been copied to the clipboard.'
        setTimeout(() => {
          this.toaster.show = false
        }, 3000)
      }
    },

    async checkConversionsCount () {
      const { data } = await window.axios.get('/campaigns/conversions/have-conversions')
      this.haveConversions = data.payload
    }
  }
}

</script>

<style lang="scss" scoped>
$descColor:  #323232;
$copyBgColor: rgba(0, 146, 215, 0.16551);

.conversions-copy {
  padding: 8px;
  margin-right: 5px;
  font-size: 12px !important;
  background: $copyBgColor;
  border-radius: 100%;

  @apply text-speakol-color;
}

.vue-tabs /deep/ .nav-tabs > li > a:hover {
  background-color: transparent;
}

/deep/.vx-card .vx-card__collapsible-content .vx-card__body {
  padding: 0;
}

.tab-title {
  @apply align-middle font-bold py-3 px-5;
}

.tab h4 {
  padding: 0;
}

.tab.active h4 {
  @apply text-speakol-color;
}

.conversions-parent {
  .conversions-card {
    background: white;
    border-radius: 20px;
    padding: 32px 35px;

    .title-status-parent {
      display: flex;

      .conversions-title {
        color: #2c2c2c;
        font-weight: 500;
        font-size: 24px;
        margin-top: 0;
        margin-bottom: 0;
        display: flex;
      }

      .conversions-status-active {
        background: #21ba45;
        border-radius: 20px;
        font-size: 14px;
        color: #fff;
        padding: 4px 16px;
        font-weight: 400;
        display: table;
        position: relative;
        top: 0;
        margin-left: 10px;
      }
    }

    .conversions-desc {
      color: $descColor;
      font-size: 14px;
      line-height: 21px;
      font-weight: 400;
      margin-top: 12px;
      margin-bottom: 32px;
    }
  }

  @media (max-width: 768px) {
    .conversions-title {
      font-size: 17px !important;
    }

    .empty-state-title {
      h4 {
        font-size: 17px !important;
      }
    }

    .empty-state-img {
      margin-top: 32px !important;

      img {
        width: 284px !important;
      }
    }

    .empty-state-desc {
      p {
        font-size: 14px !important;
      }
    }

    .conversions-status-active {
      position: relative;
      top: -2px !important;
    }

    .converstions-show-code-content {
      width: 90% !important;
      padding: 24px !important;

      h3 {
        font-size: 18px !important;
        position: relative;
        top: 10px;
      }

      .conversions-popup-close {
        button {
          width: 100%;
        }
      }

      .code-area {
        width: 100%;
        overflow-x: auto;
      }
    }
  }

  @media (max-width: 320px) {
    .empty-state-img {
      margin-top: 32px !important;

      img {
        width: 200px !important;
      }
    }
  }
}

.cyrcle {
  background: white;
  width: 4px;
  height: 4px;
  border-radius: 100%;
  display: inline-block;
  position: relative;
  top: -2px;
  margin-right: 5px;
}

.x-icon {
  cursor: pointer;
}

</style>
